module.exports = __webpack_public_path__ + "img/1920x793px.a280f7f7.png";